<template>
  <div class="assignment-tabs">
    <div class="filter-tabs">
      <div class="filter-tab bg-skill" :class="{'is-active': activeName === 'skill'}" @click="handleClick('skill')">
        <span class="filter-tab__name">Skill</span>
        <span class="filter-tab__number-lesson">{{counts['skill']}} {{counts['skill'] > 1 ? $t('homework.create_assignment.lessons_count') : $t('homework.create_assignment.lesson_count')}}</span>
      </div>
      <div class="filter-tab bg-topic" :class="{'is-active': activeName === 'topic'}" @click="handleClick('topic')">
        <span class="filter-tab__name">Topic</span>
        <span class="filter-tab__number-lesson">{{counts['topic']}} {{counts['topic'] > 1 ? $t('homework.create_assignment.lessons_count') : $t('homework.create_assignment.lesson_count')}}</span>
      </div>
      <div class="filter-tab bg-premium" :class="{'is-active': activeName === 'premium'}" @click="handleClick('premium')">
        <span class="filter-tab__name">Premium Content</span>
        <span class="filter-tab__number-lesson">{{counts['premium']}} {{counts['premium'] > 1 ? $t('homework.create_assignment.lessons_count') : $t('homework.create_assignment.lesson_count')}}</span>
      </div>
    </div>
   <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane name="skill">
        <slot name="skill"/>
      </el-tab-pane>
      <el-tab-pane name="topic">
        <slot name="topic"/>
      </el-tab-pane>
      <el-tab-pane name="premium">
        <slot name="premium"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  props:{
    counts: {
      type: Object,
      default: () => ({
        skill: 0,
        topic: 0,
        premium: 0
      })
    },
    value: {
      type: String,
      default: 'skill'
    }
  },
  data () {
    return {
      activeName: this.value
    }
  },
  methods: {
    handleClick(tabName) {
      this.activeName = tabName
      this.$emit('input', tabName)
    }
  }
}
</script>

<style lang="scss" scoped>
  .assignment-tabs {
    margin-bottom: 20px;
    .filter-tabs {
      display: flex;
      // gap: 32px;
      .filter-tab {
        display: flex;
        flex-direction: column;
        width: 359px;
        height: 108px;
        background: #EFEFF4;
        border-radius: 12px;
        margin-right: 16px;
        padding: 10px 20px 20px 20px;
        box-sizing: border-box;
        cursor: pointer;
        
        &__name {
          text-transform: uppercase;
          font-size: 24px;
          font-weight: 600;
          color: #8E8E93;
        }
        &__number-lesson {
          font-size: 14px;
          font-weight: 400;
          color: #8E8E93;
        }
      }

      .bg-skill {
        background-image: url('~@/assets/images/assignment-skill-inactive.svg');
        background-size: cover;
      }
      .bg-topic, .bg-premium {
        background-image: url('~@/assets/images/assignment-topic-inactive.svg');
        background-size: cover;
      }

      .is-active {
        .filter-tab__name {
          color: #fff;
        }
        .filter-tab__number-lesson {
          color: #FFFFFFCC;
        }
        &.bg-skill {
          background-image: url('~@/assets/images/assignment-skill-active.svg');
          background-size: cover;
        }
        &.bg-topic, &.bg-premium {
          background-image: url('~@/assets/images/assignment-topic-active.svg');
          background-size: cover;
        }
      }
    }
    ::v-deep .el-tabs  {
      &__header {
        display: none
      }
    }
  }
</style>
